import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bar", "step"]
  // La largeur vient d'un data-value (ZÉRO STYLE INLINE), plus du style="width:" ERB.
  static values = { percent: { type: Number, default: 0 } }

  connect() {
    this.animateProgressBar()
  }

  animateProgressBar() {
    if (!this.hasBarTarget) return

    const targetWidth = `${this.clampedPercent}%`
    this.barTarget.style.width = "0%"

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.barTarget.style.width = targetWidth
      })
    })
  }

  updateProgress(percentage) {
    if (this.hasBarTarget) {
      this.barTarget.style.width = `${percentage}%`
      this.barTarget.setAttribute("aria-valuenow", percentage)
    }
  }

  get clampedPercent() {
    return Math.min(Math.max(this.percentValue, 0), 100)
  }
}
